import { render, staticRenderFns } from "./footer-general-no-bg.vue?vue&type=template&id=1ed47ee3&scoped=true&"
import script from "./footer-general-no-bg.vue?vue&type=script&lang=ts&"
export * from "./footer-general-no-bg.vue?vue&type=script&lang=ts&"
import style0 from "./footer-general-no-bg.vue?vue&type=style&index=0&id=1ed47ee3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed47ee3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
